/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createNot } from '../../factoriesAny.js';
export var notDependencies = {
  typedDependencies: typedDependencies,
  createNot: createNot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNot.generated.js
// module id = 640
// module chunks = 0